import { render } from "./SelectCategoryComponent.vue?vue&type=template&id=61efd412&scoped=true"
import script from "./SelectCategoryComponent.vue?vue&type=script&lang=js"
export * from "./SelectCategoryComponent.vue?vue&type=script&lang=js"

import "./SelectCategoryComponent.vue?vue&type=style&index=0&id=61efd412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61efd412"]])

export default __exports__